import { Injectable } from '@angular/core';
import { HttpRequestPayload, IHttpErrorPayload, IHttpSuccessPayload } from '@core/models';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { CommonService } from 'src/app/common.service';
import { HttpProviderService } from '../../core/services/http-provider/http-provider.service';

@Injectable({
  providedIn: 'root'
})
export class BeneficiaryService {
  
  _beneList:any = [];
  // _beneWithDeletedList:any = [];
  filter: string;
  isBeneListEmpty:boolean = true;

  constructor(private httpProvider : HttpProviderService,private _commonService : CommonService) {
  }

  public doConfirm(context: any, success: any, failure: any) {

  }


  fetchAllBeneficiaries(): Observable<any> {
    if (this._beneList.length == 0) {
      return this.fetchBeneList().pipe(map(res => {
        return this._beneList
      }))
    }
      else {
          return of(this._beneList)

      }
  }

  fetchBeneList(): Observable<any> {
   let filter = [
      {
        key: 'criteriaDetails',
        value: '{"FilterExpression": "C1", "FilterCriteria": [{"columnName": "status", "columnType": "String", "conditions": {"searchType": "equals", "searchText": "1"} } ] }'
      }
    ]
    const httpRequest : HttpRequestPayload = {
      resource : '/beneficiary',
      queryParams: filter,
      method : "GET",
    }
    return this.httpProvider.invokeApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
    
       this._beneList = response?.body?.beneficiary;
      if(!response || !response.body || !response.body.beneficiary || response.body.beneficiary.length==0 ||response.body.beneficiary==''){
        this.isBeneListEmpty = true;
      }else{
        this.isBeneListEmpty = false;
      }
      return this._beneList;
    },
    catchError((err : IHttpErrorPayload) => { 
      this._commonService.hideSpinner();
      return throwError(err)
    })));
  }

  deleteBene(beneId): Observable<any> {

    const httpRequest : HttpRequestPayload = {
      resource : '/beneficiary/'+beneId,
      method : "DELETE",
    }
    return this.httpProvider.invokeApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      this._beneList.length = 0;
      return response?.body;
    },
    catchError((err : IHttpErrorPayload) => {
      this._commonService.hideSpinner();
      return throwError(err)
    })));

  }

  getBeneList(callback = null) {
      if(this._beneList?.length) return this._beneList;
      else { 
          this.fetchBeneList().subscribe(res=>{
              callback(res);
          });
      }
  }

  getBeneObservableListByType(paymentSystem, callback = null):Observable<any[]> {
    if (this._beneList.length == 0) {
      return this.fetchBeneList().pipe(map(res => {
        return this._beneList?.filter((item) => {return item.paymentSystem == paymentSystem})
      }))
    }
      else {
        if(paymentSystem){
          return of(this._beneList?.filter((item) => {return item.paymentSystem == paymentSystem}))
        }
      }
  }

  getBeneListByType(paymentSystem, beneFilter?):any {
      if(!this._beneList?.length) {
          return this.fetchBeneList()
          .pipe(map(res =>{
            this._beneList = res;
            if(paymentSystem){
              return (this._beneList != 0?this._beneList?.filter((item)=>{
                return (
                    //  for manage beneficiary
                    (paymentSystem =='all' && !beneFilter) ||
                    (paymentSystem =='fav' && !beneFilter && item.favourite == '1') ||
                    (item.paymentSystem == paymentSystem && !beneFilter)||
                    //  for transfer bene card click
                    (beneFilter == 'all' && item.paymentSystem == paymentSystem) || 
                    (beneFilter == 'fav' && item.paymentSystem == paymentSystem && item.favourite == '1')
                )
              }):null)
            }
          }
          ))
      }
      else {
        if(paymentSystem){
          return of(this._beneList?.filter((item)=>{
              return (
                //  for manage beneficiary
                (paymentSystem =='all' && !beneFilter) ||
                (paymentSystem =='fav' && !beneFilter && item.favourite == '1') ||
                (item.paymentSystem == paymentSystem && !beneFilter)||
                //  for transfer bene card click
                (beneFilter == 'all' && item.paymentSystem == paymentSystem) || 
                (beneFilter == 'fav' && item.paymentSystem == paymentSystem && item.favourite == '1')
              
            )
          }))
        }
   
      }
  }
  getActiveBeneById(beneId, callback = null) {
      if(!this._beneList?.length) {
        return this.fetchBeneList().pipe(map(res => {
          return  (res != 0?res.filter((item)=>{
                  return item?.beneId == beneId
              })[0]:null)
            }))
      }
      else {
        return of( this._beneList.filter((item)=>{
              return item?.beneId == beneId
          })[0])
      }
  }

  // getAllBeneById(beneId, callback = null):Observable<any> {
  //   if (!this._beneWithDeletedList?.length) {
  //     return this.fetchBeneList().pipe(map(res => {
  //       return this._beneWithDeletedList?.length > 0 ? this._beneWithDeletedList?.filter((item) => {
  //         return item?.beneId == beneId
  //       })[0] : undefined;
  //     }))
  //   }
  //   else {
  //     return of(this._beneWithDeletedList?.length > 0 ? this._beneWithDeletedList?.filter((item) => {
  //       return item?.beneId == beneId
  //     })[0] : undefined);
  //   }
  // }

  searchBeneList(filter,paymentType){
    const httpRequest : HttpRequestPayload = {
      resource : '/beneficiary',
      method : "GET",
      queryParams:[
        {
          key: "criteriaDetails",
          value: filter
        },
      ]
    }
    return this.httpProvider.invokeApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      return this._beneList = response?.body?.beneficiary?.filter((item)=>{
          return  ((paymentType == 'all' && item.status == '1') ||
                    (paymentType == 'fav' && item.status == '1' && item.favourite == '1') ||
                    (item.status == '1' && item.paymentSystem == paymentType)
                  )
    });
    },
    catchError((err : IHttpErrorPayload) => { 
      this._commonService.hideSpinner();
      return throwError(err)
    })));
  }
  getGrpByBeneList(paymentSystem, callback?) {
    if (!this._beneList?.length) {
      return this.fetchBeneList()
        .pipe(map(res => {
          return this.fiterBeneListBypaymentSystem(paymentSystem);
        }));
    }
    else {
      return of(this.fiterBeneListBypaymentSystem(paymentSystem))

    }
  }
  reloadSearchBeneList(paymentSystem,filter) {
    return this.fetchAllBeneficiaries().pipe(map(res => {
        return this.fiterBeneListBypaymentSystem(paymentSystem,filter)
    }))
}

  fiterBeneListBypaymentSystem(paymentSystem,filter?){
    if(paymentSystem && filter!='manageBene' && filter=='fav'){
      return this.getGroupByArray(this.getSortedArray(this._beneList != 0?this._beneList?.filter((item)=>{return item.favourite == '1' && item.paymentSystem == paymentSystem}):undefined, 'beneName'), 'beneName');
    }
    else if(!paymentSystem || paymentSystem =='all'){
      return this.getGroupByArray(this.getSortedArray(this._beneList, 'beneName'), 'beneName');
    }
    else if(paymentSystem =='fav'){
      return this.getGroupByArray(this.getSortedArray(this._beneList != 0?this._beneList?.filter((item)=>{return item.favourite == '1'}):undefined, 'beneName'), 'beneName');
    }
    else{
      return this.getGroupByArray(this.getSortedArray(this._beneList != 0?this._beneList?.filter((item)=>{return item.paymentSystem == paymentSystem}):undefined, 'beneName'), 'beneName');
    }
  }

  removeAllBene(){
    this._beneList = [];
  }

  getSortedArray(arr,sortByName) {
    if(arr){
      return arr?.sort( function( a, b ) {
          a = a[sortByName]?.toLowerCase();
          b = b[sortByName]?.toLowerCase();
          return a < b ? -1 : a > b ? 1 : 0;
      });
    }else{
      return undefined;
    }
  }
  getGroupByArray(arr,groupByName) {
      let data = arr?.reduce((r, e) => {
          let group = e[groupByName][0]?.toUpperCase();
          if(!r[group]) r[group] = {group, children: [e]}
          else r[group]?.children?.push(e);
          return r;
        }, {})

      return data!=null?Object.values(data):null;
  }
  
  /**
   * 
   * @param beneId 
   * @returns 
   */
  fetchBeneDetails(beneId:string):Observable<any>{
    const httpRequest : HttpRequestPayload = {
      resource : `/beneficiary/${beneId}`,
      method : "GET",
    }
    return this.httpProvider.invokeApi(httpRequest).pipe(
      map((res: IHttpSuccessPayload<any>) => {
      return res?.body?.beneficiary
    },
    catchError((err : IHttpErrorPayload) => { 
      this._commonService.hideSpinner();
      return throwError(err)
    })));
  }

  getwithinBankAccount(accountNumber:string):Observable<any>{
    const httpRequest : HttpRequestPayload = {
      resource : `/account/${accountNumber}`,
      method : "GET",
    }
    return this.httpProvider.invokeApi(httpRequest).pipe(
      map((res: IHttpSuccessPayload<any>) => {
      return res
    },
    catchError((err : IHttpErrorPayload) => { 
      this._commonService.hideSpinner();
      return throwError(err)
    })));
  }
  
}
